export default "__VITE_ASSET__e26d24ca__"